import { Component, Input, Optional, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificadoService } from 'src/app/core/services/certificado.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UsuarioAccesoService } from 'src/app/core/services/usuario_acceso.service';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import { HelpToursService } from 'src/app/core/tours/help-tours.service';
import { UsuariosGrupoModalComponent } from '../permisos-acceso/usuarios-grupo-modal/usuarios-grupo-modal.component';
import { HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { LoteCertificadoService } from 'src/app/core/services/lote-certificado.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-search-group',
    templateUrl: './search-group.component.html',
    styleUrls: ['./search-group.component.scss']
})
export class SearchGroupComponent {

    @Input() modeloAcceso!: any;
    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    currentItems: any = [];
    @Input() id!: any;
    @Input() loteId!: any;
    @Input() callback?: (data?: any) => void | Promise<void>;



    constructor(
        @Optional() public activeModal: NgbActiveModal,
        private certificadoService: CertificadoService,
        private tours: HelpToursService,
        private usuarioService: UsuariosService,
        private modalService: NgbModal,
        private usuarioAccesoService: UsuarioAccesoService,
        private notificationService: NotificationService,
        private loteCertificadoService: LoteCertificadoService
    ) { }


    // para busqueda por grupos
    async onPick(val: number | string | null): Promise<void> {


        // this.seleccion = (val === null || val === undefined || val === '') ? null : Number(val);
        // this.aplicarFiltro();
        if (!((val === null || val === undefined || val === ''))) await this.verUsuariosDelGrupo(val);
    }

    async verUsuariosDelGrupo(idGrupo: any) {
        // 1. Abrir el modal con las configuraciones deseadas
        const modalRef = this.modalService.open(UsuariosGrupoModalComponent, {
            centered: true,
            size: 'lg', // Tamaño grande para que la tabla luzca cómoda
            backdrop: 'static' // Evita que se cierre por error haciendo clic afuera
        });
        modalRef.componentInstance.itemId = this.id;
        // 2. Inyectar el ID esperado por el @Input
        modalRef.componentInstance.grupoId = idGrupo;
        modalRef.componentInstance.modeloAcceso = this.modeloAcceso;
        modalRef.componentInstance.accionLabel = 'Incluir';


        modalRef.componentInstance.onAgregar = async (data: any) => {

            const certificados = data.usuarios
                .filter((item: any) => item.permitido === true)
                .map((item: any) => item.default_cert);

            modalRef.close();
            let response = await lastValueFrom(this.loteCertificadoService.postLotesCertificados({ certificados }, this.loteId))

            if (response.message) {
                Swal.fire(
                    response?.message,
                    '',
                    'success'
                );
                if (this.callback) {
                    this.callback({ success: true })
                }
            } else {
                if (this.callback) {
                    this.callback({ success: false })
                }
            }


        };


        // 3. Capturar el cierre si necesitas hacer algo al terminar
        modalRef.result.then((result) => {
            //this.listUsuarioAcceso();
        }).catch(() => { });


    }

    async listUsuarioAcceso() {
        let params = new HttpParams();
        params = params.set('page', this.currentPage).set('limit', this.pageSize).set('pagination', true).set('id_item', String(this.id));
        const response = await lastValueFrom(this.usuarioAccesoService.get({ params }));
        this.currentItems = (response as any).body.map((x: any, index: number) => {
            return {
                id: x.id,
                nombre: `${x.usuario.firstName} ${x.usuario.lastName}`,
                correo: x.usuario.email,
            }
        });
    }

}